import React from "react";
import numeral from "numeral";

const MTDCell: React.FC<{ value: number }> = ({ value }) => (
    <div className="cell-wrapper currency-cell">{numeral(value).format("0,0.00")}</div>
);

export default MTDCell;
